import { DigitalId, ComplianceResult } from './../model/digital-id';
import { RiskResult } from './../model/risk-profile.model';
import { Injectable } from '@angular/core';

import { SearchTypeEnum } from '@enum/search.enum';
import { DEFAULT_COUNTRY_CODE, DEFUALT_NATIONALITY_CODE } from '@constant/default.constant';
import { Party, Address, Person, Company, PartyConsent } from '@model/party.model';
import { Gender } from '@enum/party.enum';
import { RiskProfile } from '@model/risk-profile.model';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment } from '@environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PartyService {
  constructor(private http: HttpClient) {}

  defaultAddress: Address = {
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    addressLine4: '',
    countryCode: DEFAULT_COUNTRY_CODE,
    provinceCode: null,
    districtCode: null,
    subDistrictCode: null,
    zipCode: null
  };

  personPartyBuilder(searchType: string = SearchTypeEnum.PASSPORT_NO, identificationNo: string = ''): Party {
    const person: Person = {
      nationalId: searchType === SearchTypeEnum.NATIONAL_ID ? parseInt(identificationNo, 10) : null,
      passportNumber: searchType === SearchTypeEnum.PASSPORT_NO ? identificationNo : null,
      nationality: searchType === SearchTypeEnum.NATIONAL_ID ? DEFUALT_NATIONALITY_CODE : null,
      gender: Gender.MALE,
      title: null,
      firstName: '',
      lastName: '',
      firstNameTh: '',
      lastNameTh: '',
      birthDate: '',
      email: '',
      occupation: null,
      mobileNumber: null
    };
    const company: Company = {
      registrationNumber: null,
      companyPrefix: null,
      companySuffix: null,
      companyName: null,
      companySuffixTh: null,
      companyNameTh: null,
      mainBranch: true,
      branch: null,
      businessTypeCode: null,
      contactName: null,
      email: null,
      mobileNumber: null
    };

    return {
      id: '',
      partyType: 'PERSON',
      customerSegmentCode: null,
      person,
      company,
      consents: [],
      registrationAddress: this.defaultAddress,
      englishRegistrationAddress: this.defaultAddress,
      deliveryAddress: null,
      englishDeliveryAddress: null
    };
  }

  setEnglishRegistrationAddressWhenEmpty(party: Party): Party {
    if (party && party.registrationAddress && !party.englishRegistrationAddress) {
      return {
        ...party,
        englishRegistrationAddress: {
          ...this.defaultAddress,
          provinceCode: party.registrationAddress.provinceCode,
          districtCode: party.registrationAddress.districtCode,
          subDistrictCode: party.registrationAddress.subDistrictCode,
          zipCode: party.registrationAddress.zipCode
        }
      };
    } else {
      return party;
    }
  }

  checkAmlo(body: RiskProfile): Observable<RiskResult> {
    const url: string = `${environment.endpoint}/riskprofiles`;
    return this.http.post<RiskResult>(url, body);
  }

  validateDigitalId(body: DigitalId): Observable<ComplianceResult[]> {
    const url: string = `${environment.endpoint}/digitalid`;
    return this.http.post<ComplianceResult[]>(url, body);
  }
}
